import React from 'react';
import { Add } from '@mui/icons-material';

const TXT_EQUIP = { fr: 'Équiper', en: 'Equip', de: 'Ausrüsten', es: 'Equipar', pt: 'Equipar' };

/**
 * Primary action for item/set overlays.
 * `footer` (default): full-width, matches the slot replace footer.
 * `header`: compact pill the Overlay promotes into its top bar on desktop.
 */
const OverlayEquipFooter = ({ lang = 'fr', label, onEquip, disabled = false, variant = 'footer' }) => {
    if (!onEquip) return null;

    const text = label || TXT_EQUIP[lang] || TXT_EQUIP.en;
    const isHeader = variant === 'header';

    const button = (
        <button
            type="button"
            className={isHeader ? 'overlay-header-equip' : 'primary alt overlay-footer-primary'}
            disabled={disabled}
            onClick={(e) => {
                e.stopPropagation();
                onEquip();
            }}
        >
            <Add sx={{ fontSize: isHeader ? '1rem' : '1.1rem' }} />
            <span>{text}</span>
        </button>
    );

    if (isHeader) return button;

    return <div className="overlay-footer-actions">{button}</div>;
};

export default OverlayEquipFooter;
export { TXT_EQUIP };
